export const CAT = {
  organizer: { label: "Organizer / Tournament Director", short: "Organizer", pct: "50%" },
  participant: { label: "Verified Event Participants", short: "Event Participants", pct: "30%" },
  acquaintance: { label: "Verified Acquaintances / Club Members", short: "Acquaintances", pct: "20%" },
};

export const CRITERIA = [
  ["skill", "Overall Playing Skill"],
  ["consistency", "Consistency"],
  ["awareness", "Court Awareness / Decision Making"],
  ["sportsmanship", "Sportsmanship"],
  ["overall", "Overall Rating"],
];

export const LEVELS = [
  [0.0, "Newbie", "Brand new to pickleball; learning how to hold the paddle, basic rules, and how to keep score."],
  [1.0, "Beginner", "Minimal experience; learning proper contact, basic serves, and getting used to court movement."],
  [1.5, "High Beginner", "Can sustain short rallies with players of equal ability and understands the two-bounce rule."],
  [2.0, "Low Novice", "Moves comfortably across the court, consistently gets basic serves in, and grasps simple gameplay patterns."],
  [2.5, "Novice", "Understands court positioning, beginning to perfect the serve, and starting to play the soft game at the kitchen line."],
  [3.0, "High Novice", "Solid recreational player; maintains medium-length dink rallies and knows basic third-shot strategies."],
  [3.25, "Low Intermediate", "Developing control over shot selection and height/depth on dinks; starting to incorporate more deliberate strategies."],
  [3.5, "Intermediate", "Consistent on medium-paced shots, can serve deep reliably, and utilizes basic third-shot drops and kitchen tactics."],
  [3.75, "High Intermediate", "Possesses a strong grasp of both hard and soft games; actively spots opponent weaknesses and makes fewer unforced errors."],
  [4.0, "Advanced", "Anticipates play well, handles pace changes easily, uses advanced strategies like stacking, and plays with high consistency."],
  [4.4, "Advanced 2", "Highly skilled tactical player; capable of advanced resets, high-level counter-attacking, ATPs, and Ernes with minimal unforced errors."],
  [4.8, "Advanced 3", "Elite amateur or open-level tournament player; near-mastery of all physical, mental, and strategic facets of the game under intense pressure."],
  [5.5, "Professional", "Touring pros and top-tier tier-one tournament champions whose performance and consistency define the pinnacle of the sport."],
];

export function levelFor(v) {
  if (v == null) return null;
  let cur = LEVELS[0];
  for (const l of LEVELS) if (v >= l[0]) cur = l;
  return { min: cur[0], name: cur[1], desc: cur[2] };
}

export const fmt = (v) => (v == null ? "—" : Number(v).toFixed(2));
export const levelName = (v) => levelFor(v)?.name || "";

export const rateUrl = (token) => `${window.location.origin}/rate/player/${token}`;

export function requestMessage(name, url) {
  return `Hi! It's ${name || "me"} — here's my PointControl.Pro profile. 👋\n\nI'd appreciate it if you could rate me based on your experience playing with me. Your honest feedback helps build my player profile.\n\n👉 Click here to rate me: ${url}`;
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
}

export async function shareRequest(name, url) {
  const text = `Hi! Here's my PointControl.Pro profile. I'd appreciate your honest rating based on your experience playing with me.\n\n👉 Rate me here: ${url}`;
  if (navigator.share) {
    try {
      await navigator.share({ title: `${name} on PointControl.Pro`, text, url });
      return "shared";
    } catch (e) {
      if (e?.name === "AbortError") return "cancelled";
    }
  }
  await copyText(text);
  return "copied";
}
